import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";

const Thanks = () => {
  const handleCloseWindow = () => {
    window.close();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-muted flex items-center justify-center p-4">
      <Card className="w-full max-w-md border-success/20">
        <CardContent className="p-8 text-center space-y-6">
          <div className="flex justify-center">
            <CheckCircle className="h-16 w-16 text-success" />
          </div>
          
          <div className="space-y-2">
            <h1 className="text-2xl font-bold text-foreground">
              Obrigado!
            </h1>
            <p className="text-muted-foreground">
              Confirmação de recebimento do email realizada com sucesso.
            </p>
          </div>
          
          <Button 
            onClick={handleCloseWindow}
            className="w-full"
          >
            Fechar Janela
          </Button>
          
          <p className="text-sm text-muted-foreground">
            Você pode fechar esta janela a qualquer momento.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default Thanks;